import React from "react";

import { FaCheckCircle, FaExclamationTriangle } from "react-icons/fa";

import Button from "../UI/Button";
import { openCalendly } from "../Product-LMS/calendly";

const sessionItems = [
  { text: "Candidate ID verified" },
  { text: "Single face in frame" },
  { text: "Secure browser active" },
  { text: "Second screen detected: flagged for review", flag: true },
  { text: "Session recording in progress" },
];

const HeroSection = () => {
  return (
    <>
      <section className="container text-primary">
        <div className="w-full rounded-xl bg-gradient-to-br from-[#0b2b4f] to-quaternary px-6 py-12 lg:px-14 lg:py-16">
          <div className="grid grid-cols-1 lg:grid-cols-[1.15fr_0.85fr] gap-10 lg:gap-14 items-center">
            <div className="text-tertiary">
              <h1 className="text-3xl lg:text-5xl font-bold leading-tight">
                Online Exam &amp; Remote Proctoring Services
              </h1>
              <h2 className="text-xl lg:text-2xl font-semibold pt-4">
                Secure Online Exams. Zero Compromise on Integrity.
              </h2>
              <p className="pt-4 pb-8 text-white/80 leading-7 max-w-xl">
                Exam Online is an AI-powered online exam and remote proctoring
                service from IQSPL. It helps universities, corporates, and
                certification bodies run credible exams from anywhere, without
                physical exam centres.
              </p>
              <Button onClick={openCalendly}>Book a demo</Button>
            </div>

            <div
              className="rounded-xl bg-white/10 border border-white/20 p-6"
              aria-hidden="true"
            >
              <h3 className="text-tertiary font-semibold pb-3 mb-2 border-b border-white/20">
                Live exam session
              </h3>
              <ul>
                {sessionItems.map((item) => (
                  <li
                    key={item.text}
                    className="flex items-center gap-3 py-2 text-white/90 text-sm lg:text-base"
                  >
                    {item.flag ? (
                      <FaExclamationTriangle className="shrink-0 text-amber-400" />
                    ) : (
                      <FaCheckCircle className="shrink-0 text-emerald-400" />
                    )}
                    {item.text}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
